import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M320 1221.33C320 1188.93 346.266 1162.67 378.667 1162.67H1114.67C1147.07 1162.67 1173.33 1188.93 1173.33 1221.33 1173.33 1253.73 1147.07 1280 1114.67 1280H378.667C346.266 1280 320 1253.73 320 1221.33zM1386.67 1221.33C1386.67 1188.93 1412.93 1162.67 1445.33 1162.67H1541.33C1573.73 1162.67 1600 1188.93 1600 1221.33 1600 1253.73 1573.73 1280 1541.33 1280H1445.33C1412.93 1280 1386.67 1253.73 1386.67 1221.33zM805.333 1482.67C772.933 1482.67 746.667 1508.93 746.667 1541.33 746.667 1573.73 772.933 1600 805.333 1600H1541.33C1573.73 1600 1600 1573.73 1600 1541.33 1600 1508.93 1573.73 1482.67 1541.33 1482.67H805.333zM320 1541.33C320 1508.93 346.266 1482.67 378.667 1482.67H474.667C507.067 1482.67 533.333 1508.93 533.333 1541.33 533.333 1573.73 507.067 1600 474.667 1600H378.667C346.266 1600 320 1573.73 320 1541.33z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 213.333C0 95.5126 95.5126 0 213.333 0H1706.67C1824.49 0 1920 95.5126 1920 213.333V1706.67C1920 1824.49 1824.49 1920 1706.67 1920H213.333C95.5126 1920 0 1824.49 0 1706.67V213.333ZM213.333 117.333H1706.67C1759.69 117.333 1802.67 160.314 1802.67 213.333V1706.67C1802.67 1759.69 1759.69 1802.67 1706.67 1802.67H213.333C160.314 1802.67 117.333 1759.69 117.333 1706.67V213.333C117.333 160.314 160.314 117.333 213.333 117.333Z",
  fillRule: "evenodd"
}));

var IconSubtitlesLine = /*#__PURE__*/function (_Component) {
  _inherits(IconSubtitlesLine, _Component);

  var _super = _createSuper(IconSubtitlesLine);

  function IconSubtitlesLine() {
    _classCallCheck(this, IconSubtitlesLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconSubtitlesLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconSubtitles",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconSubtitlesLine.displayName = "IconSubtitlesLine";
  return IconSubtitlesLine;
}(Component);

IconSubtitlesLine.glyphName = 'subtitles';
IconSubtitlesLine.variant = 'Line';
IconSubtitlesLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconSubtitlesLine;
export { IconSubtitlesLine };